import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { Reveal } from "@/components/site/Reveal";
import { Seo } from "@/components/site/Seo";
import { Link } from "react-router-dom";

const About = () => (
  <>
    <Seo
      title="Clearview — about"
      description="Built for the person who carries the numbers alone. An independent second opinion that takes a side."
      path="/about"
    />
    <Header />

    <section className="ph">
      <div className="container">
        <Reveal>
          <div className="eyebrow eyebrow-light">About</div>
          <h1 style={{ marginTop: 14, maxWidth: 780, marginLeft: "auto", marginRight: "auto" }}>
            Built for the person who <span className="gtext">carries the numbers alone.</span>
          </h1>
          <p className="lead">
            Every owner-operator makes the big calls by themselves. We thought they deserved a second opinion that actually takes a side.
          </p>
        </Reveal>
      </div>
    </section>

    <section className="pad">
      <div className="container narrow-760 prose">
        <Reveal>
          <p className="big">There's a particular kind of quiet that comes with running your own business.</p>
          <p>
            You're the one who signs off the hire. Who decides whether to raise the price. Who lies awake wondering if a customer's about to go under, or if this month was actually any good. Your accountant works for the tax office. Your bookkeeper works for the reconciliation. The software records what already happened. None of them are looking at the business <em>for you</em>.
          </p>
          <p>
            That gap — between everything you could know about your own business and what you actually have time to know — is where the expensive mistakes live. Not because owners are careless. Because they're flat out, and there's no one in the room to say "wait, not yet" or "yes, you can afford it."
          </p>
          <p>
            Clearview is that someone. An independent read that looks at the whole business, takes a clear position on what to do, and is honest enough to say when it can't call it. Not another dashboard to stare at. A straight answer, any time you need one.
          </p>
          <p>
            We built it because the advice that owner-operators most need has always been locked behind a CFO most of them can't yet justify. It shouldn't be. The read a good CFO gives should be available to the tens of thousands of businesses holding the whole thing together on instinct.
          </p>
        </Reveal>
      </div>
    </section>

    <section className="band-grey pad">
      <div className="container">
        <Reveal className="center">
          <div className="eyebrow">What we believe</div>
          <h2 style={{ fontSize: "clamp(26px,4vw,38px)", color: "var(--navy)", marginTop: 14 }}>
            The rules we build by.
          </h2>
        </Reveal>
        <Reveal className="beliefs">
          <div className="belief"><div className="d" /><h3>Independent or nothing</h3><p>We're not your accounting vendor and never will be. We work for the owner — which is the only way a second opinion is worth anything.</p></div>
          <div className="belief"><div className="d" /><h3>Take a side</h3><p>"Here's a chart" isn't help. We say hire or wait, buy or hold, chase or let it go — and show the working so you can decide.</p></div>
          <div className="belief"><div className="d" /><h3>Honest when we can't tell</h3><p>If the numbers don't support a call, we say so and refuse. A second opinion that always has an answer isn't one.</p></div>
        </Reveal>
      </div>
    </section>

    <section className="pad">
      <div className="container kindra">
        <Reveal>
          <div className="eyebrow center">The family</div>
          <div className="logo-k" style={{ marginTop: 16 }}>Kindra<span className="ai">AI</span></div>
          <p style={{ color: "var(--muted)", marginTop: 18, fontSize: 17, maxWidth: 600, marginLeft: "auto", marginRight: "auto" }}>
            Clearview is a Kindra company. Kindra builds calm, plain-English tools that help Australian owner-operators see what's really going on in their business — find the leaks, make the call, no jargon and no lock-in. Clearview is that mission pointed at the hardest part: the decision itself.
          </p>
        </Reveal>
      </div>
    </section>

    <section className="pad" style={{ paddingTop: 0 }}>
      <div className="container">
        <Reveal>
          <div className="final">
            <div className="inner">
              <h2>See what it says<br /><span className="gtext">about your business.</span></h2>
              <p>A free, no-pitch demo — bring a real decision and we'll show you the read.</p>
              <Link className="pill" to="/apply" data-testid="about-final-cta">Book a free demo</Link>
              <p className="fine">A free, no-pitch demo · read-only · no lock-in</p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>

    <Footer />
  </>
);

export default About;
